import { Link } from 'react-router-dom';

import photoDerecha from '../../img/fotos/Foto_Sobre_Mi_Derecha.jpg';
import photoIzquierda from '../../img/fotos/Foto_Sobre_Mi_Izquierda.jpg';

import Clientes from '../../components/Clientes/Clientes';
import Manual from '../../components/Manual/ManualInicio';
import MiEstilo from '../../components/MiEstilo/MiEstilo';
import VolverArriba from '../../components/VolverArriba/VolverArriba';

import { useIdioma } from '../../context/IdiomaContext';

import './SobreMi.css';

function SobreMi() {
  const { t } = useIdioma();

  const recorridoParrafos = t(
    'sobreMiPagina.recorrido.parrafos'
  );

  const manifiestoParrafos = t(
    'sobreMiPagina.manifiesto.parrafos'
  );

  const principios = t(
    'sobreMiPagina.principios.lista'
  );

  return (
    <div className="pagina-sobre-mi-completa">
      {/* Primera sección */}

      <section className="pagina pagina-sobre-mi">
        <div className="sobre-mi-contenido">
          <p className="pagina-etiqueta">
            {t(
              'sobreMiPagina.recorrido.etiqueta'
            )}
          </p>

          <h1>
            {t(
              'sobreMiPagina.recorrido.titulo'
            )}
          </h1>

          {recorridoParrafos.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}

          <Link
            to="/contacto"
            className="pagina-boton"
          >
            {t(
              'sobreMiPagina.recorrido.boton'
            )}
          </Link>
        </div>

        <div className="sobre-mi-imagen">
          <img
            src={photoDerecha}
            alt={t(
              'sobreMiPagina.recorrido.imagenAlt'
            )}
          />
        </div>
      </section>

      {/* Segunda sección: manifiesto */}

      <section className="sobre-mi-seccion sobre-mi-manifiesto">
        <div className="sobre-mi-manifiesto-contenido">
          <h2>
            {t(
              'sobreMiPagina.manifiesto.titulo'
            )}
          </h2>

          {manifiestoParrafos.map(
            (parrafo, index) => (
              <p key={index}>{parrafo}</p>
            )
          )}
        </div>
      </section>

      {/* Tercera sección: principios */}

      <section className="sobre-mi-principios">
        <div className="sobre-mi-principios-imagen">
          <img
            src={photoIzquierda}
            alt={t(
              'sobreMiPagina.principios.imagenAlt'
            )}
          />
        </div>

        <div className="sobre-mi-principios-contenido">
          <h2>
            {t(
              'sobreMiPagina.principios.titulo'
            )}
          </h2>

          <div className="principios-lista">
            {principios.map(
              (principio, index) => (
                <article
                  className="principio"
                  key={index}
                >
                  <h3>{principio.titulo}</h3>

                  <p>
                    {principio.descripcion}
                  </p>
                </article>
              )
            )}
          </div>

          <Link
            to="/contacto"
            className="sobre-mi-seccion-boton"
          >
            {t(
              'sobreMiPagina.principios.boton'
            )}{' '}
            →
          </Link>
        </div>
      </section>

      <MiEstilo />
      <Clientes />
      <Manual />
      <VolverArriba />
    </div>
  );
}

export default SobreMi;